import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'

interface IProps {
  isOpen: boolean
  setModal: (value: boolean) => void
  onClick: (isApproved: boolean) => Promise<void>
  loading: boolean
}

const ModalActionSawitPoin = (props: IProps) => {
  const { isOpen, setModal, onClick, loading } = props

  return (
    <Modal
      data-testid="modal-sawitpoin-confirm"
      open={isOpen}
      footer={null}
      onCancel={() => setModal(false)}
      closable={false}
    >
      <Typography.Paragraph className="text-lg text-center font-semibold">
        Konfirmasi Permintaan Pencairan SawitPoin
      </Typography.Paragraph>
      <Typography.Paragraph className="text-lg text-center">
        Pencairan akan diteruskan ke pengguna.
      </Typography.Paragraph>
      <div className="flex mt-4">
        <Button
          disabled={loading}
          block
          onClick={() => setModal(false)}
          data-testid="btn_cancel"
          className="inline-block mr-4 font-bold uppercase"
          label="Batalkan"
        />
        <Button
          disabled={loading}
          block
          onClick={() => onClick(true)}
          data-testid="btn_accept"
          className="inline-block font-bold uppercase"
          label="konfirmasi"
          variant="solid-primary"
        />
      </div>
    </Modal>
  )
}

export default ModalActionSawitPoin
